export enum FLAGS {
    ADD_TO_LIST = 'addToList',
    BULK_UPLOADS = 'bulkUploads',
    COMPARE_SIMULATIONS = 'compareSimulations',
    CREATE_RULE = 'createRule',
    DEMO = 'demo',
    EXECUTION_ORDER = 'executionOrder',
    GLOBAL_RULES = 'globalRules',
    LIST_MANAGEMENT = 'listManagement',
    MANAGE_PARAMETERS = 'manageParameters',
    NETWORK_RULES = 'networkRules',
    PAN_LIST = 'panList',
    RANGELISTTYPE = 'rangeListType',
    REPORTS = 'reports',
    REVIEW_CONCLUSIONS = 'reviewConclusions',
    REVISIONS = 'revisions',
    RULE_GROUP_CONDITIONS = 'ruleGroupConditions',
    SCHEDULED_DEPLOYMENT = 'scheduledDeployment',
    SET_FLAGS = 'setFlags',
    SHOW_ADVANCED_RULE = 'showAdvancedRule',
    SHOW_ALL_MERCHANT_RELATED = 'showAllMerchantRelated',
    SHOW_MANAGE_TENANTS = 'showManageTenants',
    SIMULATION_CURRENT_DATE = 'simulationCurrentDate',
    SIMULATIONS = 'simulations',
    TABLEAU_REPORTS = 'tableauEnabled',
    TENANT_GROUPS = 'tenantGroups',
    DISABLE_LEGACY_REPORTS = 'disableLegacyReports'
}

export const DATE_RANGES_TYPES: Readonly<{
    CUSTOM: 'Custom';
    PAST_DAYS: 'Past Days';
    MONTH: 'Month';
    YEAR: 'Year';
    MONTH_TO_DATE: 'Month to Date';
    YEAR_TO_DATE: 'Year to Date';
}> = Object.freeze({
    CUSTOM: 'Custom',
    PAST_DAYS: 'Past Days',
    MONTH: 'Month',
    YEAR: 'Year',
    MONTH_TO_DATE: 'Month to Date',
    YEAR_TO_DATE: 'Year to Date'
});

export const FOCUS_VIEW = Object.freeze({
    ACCEPT: 'Accept',
    REJECT: 'Reject',
    REVIEW: 'Review'
});

export const SORT_VIEW = Object.freeze({
    ALPHANUMERICAL: 'Alphanumerical',
    HIGH: 'High',
    LOW: 'Low'
});

export const COMPARE_SORT_VIEW = Object.freeze({
    ALPHANUMERICAL: 'Alphanumerical',
    DEPLOYED_HIGH: 'Deployed High',
    DEPLOYED_LOW: 'Deployed Low',
    SANDBOX_HIGH: 'Sandbox High',
    SANDBOX_LOW: 'Sandbox Low'
});

export const SIMULATION_FILTER = Object.freeze({
    ALL: 'All Rules',
    MODIFIED: 'Modified Rules Only',
    NEW: 'New Rules Only'
});

export const MerchantReportTypeValue = Object.freeze({
    allMerchants: 'All Merchants',
    singleMerchant: 'Single Merchant'
});

export const RuleType = Object.freeze({
    GlobalRules: 'globalRules',
    MerchantOverrides: 'merchantOverrides'
});

export enum SCHEDULED_DEPLOYMENT_STATUS {
    in_progress = 'In Progress',
    failed = 'Failed',
    scheduled = 'Scheduled',
    done = 'Done'
}

export const DEPLOYMENT_STATUS = Object.freeze({
    STARTED: 'started',
    FAILED: 'failed',
    COMPLETE: 'complete'
});

export const LIST_TYPES: Readonly<{
    GENERAL: 'GENERAL';
    PAN: 'PAN';
    RANGE: 'RANGE';
}> = Object.freeze({
    GENERAL: 'GENERAL',
    PAN: 'PAN',
    RANGE: 'RANGE'
});

export const PCI_LIST_TYPES = [LIST_TYPES.PAN];

export enum ListTypePlaceholderText {
    PAN = 'Enter primary account number',
    GENERAL = 'Search',
    RANGE = 'Search'
}

export const MERCHANT_OPTIONS = Object.freeze({
    ALL_MERCHANTS: 'All Merchants',
    SINGLE_MERCHANT: 'Single Merchant'
});

export const SIMULATION_STATUS = Object.freeze({
    QUEUED: 'QUEUED',
    DEPLOYING: 'DEPLOYING_SIMULATION_FILES',
    PROCESSING: 'IN_PROGRESS',
    FINISHED: 'FINISHED',
    DEPLOYMENT_FAILED: 'SIMULATION_FILES_DEPLOYMENT_FAILED',
    FAILED: 'FAILED'
});

// TODO: move to BCATS
// file reps as bytes
const oneMB = 1_048_576;
export const FILE_SIZES = Object.freeze({
    '1 MB': oneMB,
    '2 MB': oneMB * 2,
    '10 MB': oneMB * 10,
    '100 MB': oneMB * 10 * 10,
    '1 GB': 1_073_741_824
});

export const RULE_INPUT_PARAMETER_NAMES = Object.freeze({
    SCORE: 'score',
    THRESHOLD: 'threshold',
    CURRENCY: 'currency',
    COMMENT: 'comment',
    PAYER_AUTH_STR: '3ds',
    ACCOUNT: 'accountId',
    LISTS: 'lists',
    RULE_ID: 'ruleId',
    GROUP: 'group',
    PRIORITY: 'priority',
    ACTIVE: 'active',
    NAME: 'name',
    ACTIONS: 'actions',
    DESCRIPTION: 'description',
    ALLOW_OVERRIDES: 'allowOverrides',
    HIDDEN_FROM_TENANTS: 'hiddenFromTenant'
});

export const INPUT_PARAMETER_TYPES = Object.freeze({
    STRING: 'string',
    DECIMAL: 'decimal',
    INTEGER: 'integer',
    LIST: 'list'
});

export enum RULE_ACTION_TYPE {
    ACCEPT = 'ACCEPT',
    REJECT = 'REJECT',
    REVIEW = 'REVIEW',
    UPDATE_SCORE_BY = 'UPDATE_SCORE_BY',
    SET_FLAGS = 'SET_FLAGS',
    ADD_TO_LIST = 'ADD_TO_LIST'
}

export enum Conclusion {
    ACCEPT = 'Accept',
    REJECT = 'Reject',
    REVIEW = 'Review',
    SEE_RULE_DETAILS = 'See rule details',
    UPDATE_SCORE_BY_SCORE = 'Update score by [score]',
    SCORE_SCORE = 'Score [score]'
}

export const OPERATOR_CONDITIONS = Object.freeze({
    EQ: 'eq',
    NEQ: 'neq',
    GT: 'gt',
    LT: 'lt',
    GTEQ: 'ge',
    LTEQ: 'le',
    STR_IN_LIST: 'strinlist',
    STR_NOT_IN_LIST: 'strnotinlist',
    STR_EQ: 'streq',
    STR_NEQ: 'strneq',
    STR_IN: 'strin',
    STR_NOT_IN: 'strnotin',
    STR_CONTAINS: 'strcontains',
    STR_NOT_CONTAINS: 'strnotcontains'
});

export const PARAMETERS_PARAM_TYPES = Object.freeze({
    STRING: 'STRING',
    CURRENCY: 'CURRENCY',
    NUMBER: 'NUMBER',
    PAN: 'PAN'
});

export const NEW_RULE_SOURCE_TYPES = Object.freeze({
    VELOCITY_COUNT: 'VELOCITY_COUNT',
    VELOCITY_SUM: 'VELOCITY_SUM'
});

export const NEW_RULE_CONDITION_VALUE_TYPES = Object.freeze({
    STRING: 'STRING',
    CURRENCY: 'CURRENCY',
    NUMBER: 'NUMBER',
    FREE_ENTRY: 'FREE_ENTRY',
    LIST: 'LIST',
    DATETIME: 'DATETIME'
});

export enum Levels {
    ACQUIRER = 'ACQUIRER',
    MERCHANT = 'MERCHANT',
    TENANT_GROUP = 'TENANT_GROUP'
}

export const GLOBAL_RULE_TABLE_VIEW = 'Rule Group View';
export const GLOBAL_EXECUTION_ORDER_VIEW = 'Execution Order View';
export const GLOBAL_RULE_TABLE_ORDER: GlobalRuleViewOptions[] = [
    { label: 'Rule Group View', value: 'Rule Group View' },
    { label: 'Execution Order View', value: 'Execution Order View' }
];
export enum GlobalRuleType {
    ADVANCED_RULE = 'Advanced Rule',
    SIMPLE_RULE = 'Simple Rule'
}

export enum RulesTypes {
    ADVANCED = 'advanced',
    SIMPLE = 'simple'
}

export const EDIT_TENANT_GROUP_FIELDS = Object.freeze({
    NAME: 'name',
    DESCRIPTION: 'description'
});

export const ADVANCED_RULE_PARAMETER_MAPPING: Readonly<Record<string, string>> = Object.freeze({
    STRING: 'string',
    CURRENCY: 'float',
    NUMBER: 'int'
});

export const SELECT_PLACEHOLDER_TEXT = 'Select Action';
export const SELECT_FLAG_PLACEHOLDER_TEXT = 'Select Flags';
export const HIDDEN_LIST_TYPES = {
    RANGE: 'RANGE'
};

export const COLOR = {
    GREEN: '#038A00',
    RED: '#A82226',
    BLUE: '#0023CF',
    GREY: '#E8E5E1',
    DARK_GREY: '#B1ADA6'
};

export enum IMPORT_EXPORT_STATUS {
    QUEUED = 'QUEUED',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED',
    FAILED = 'FAILED',
    CANCELLING = 'CANCELLING',
    CANCELLED = 'CANCELLED'
}

export enum IMPORT_EXPORT_PROCESS_TYPE {
    IMPORT = 'IMPORT',
    EXPORT = 'EXPORT'
}

export enum FILE_UPLOAD_STATUS {
    IDLE = 'IDLE',
    INITIATED = 'INITIATED',
    UPLOADING = 'UPLOADING',
    UPLOADED = 'UPLOADED'
}

export enum IMPORTER_START_UPLOAD_SCHEMA {
    FILE_NAME = 'fileName'
}

export enum IMPORTER_UPLOAD_PART_SCHEMA {
    FILE_NAME = 'fileName',
    UPLOAD_ID = 'uploadId',
    PART_NUMBER = 'partNumber',
    TOTAL_PARTS = 'totalParts',
    PART_DATA = 'partData'
}

export enum IMPORTER_FILE_DELETE_SCHEMA {
    FILE_NAME = 'fileName',
    UPLOAD_ID = 'uploadId'
}

export enum SIDE_PANEL_CONTENT_TYPE {
    QUEUE = 'queue',
    COMPLETED = 'completed'
}

export enum RULE_TEST_STATUS {
    QUEUED = 'QUEUED',
    IN_PROGRESS = 'IN_PROGRESS',
    FAILED = 'FAILED',
    FINISHED = 'FINISHED',
    CANCELLED = 'CANCELLED'
}
